export const OfferStatusType = {
    NORMAL: "NORMAL",
    WAITING_SIGNATURE: "WAITING_SIGNATURE",
    WAITING_WITHDRAW_SIGNATURE: "WAITING_WITHDRAW_SIGNATURE"
}
